import React , {Component} from 'react';
import { connect } from "react-redux";
import NumberFormat from 'react-number-format';
import buttonPlusIcon from './../../assets/images/icons/button-plus.svg';
import buttonPlusDeactivateIcon from './../../assets/images/icons/button-plus-deactivate.svg';
import buttonMinusIcon from './../../assets/images/icons/button-minus.svg';

import {addToUserCart  , addToCart  , removeFromUserCart , removeFromCart  } from "./../../../actions";
import {Modal} from "react-bootstrap";
import timerIcon from "../../assets/images/icons/timer.svg";

import { Swiper , Autoplay , Pagination } from 'swiper';
Swiper.use([ Autoplay , Pagination]);

class ProductCard extends Component{

    constructor(props){

        super(props)

        this.state = {
            galleryShowModal: false,
            gallerySlider : [] ,
            loadedImages: {}
        }
    }

    buttonPlusHandler(){
        if (localStorage.getItem( "orderDeliveryDateTitle" ) !== null &&
            localStorage.getItem( "orderDeliveryTimeTime" ) !== null &&
            localStorage.getItem( "orderDeliveryTimePreview" ) !== null &&
            localStorage.getItem( "orderDeliveryTimePreview" ) == 'true')
        {
            this.props.addToCart(this.props.product.id)
            this.props.addToUserCart(this.props.product.id)
            this.props.cartHandler()
        }
        else
        {
            this.props.needPreOrder()
        }
    }
    componentDidMount() {
        const { product } = this.props;
        if (product?.images) {
            this.setState({ gallerySlider: product.images });
        }
    }

    buttonMinusHandler(){
        this.props.removeFromCart(this.props.product.id)
        this.props.removeFromUserCart(this.props.product.id)
        this.props.cartHandler()
    }

    componentDidUpdate(prevProps, prevState){
        /*if (prevState.gallerySlider !== this.state.gallerySlider){
            let gallerySlider = new Swiper('#gallery-slider', {
                slidesPerView: 1,
                spaceBetween: 15,
                autoplay: {
                    delay: 3000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            })
        }*/
    }

    galleryShowHandler(){
        this.setState({
            galleryShowModal : !this.state.galleryShowModal
        })




        setTimeout(
            function() {

                let gallerySlider = new Swiper('#gallery-slider', {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                    },

                })
                gallerySlider.update()

            }
                .bind(this),
            100
        )



    }

    render(){
        const { product , currentTime  } = this.props

        let available = false
        let unavailableForPreOrder = false
        let availableShowForPreOrderMessage = null
        let imgClass = 'img-container'
        let daily_stock_count_sens_status = false
        let daily_stock_count = 0
        let daily_stock_text = ''
        if (product.daily_stock_count_sens_status === true) {
            daily_stock_count_sens_status = true;
            daily_stock_count = product.daily_stock_count
            daily_stock_text =   product.daily_stock_count + ' عدد باقی مانده'
        }
        let orderInPreOrder = localStorage.getItem("orderInPreOrder") !== null && localStorage.getItem("orderInPreOrder") == 'true'
        if (
            Boolean(product.available) === true ||
            (localStorage.getItem( "orderInPreOrder" ) !== null && localStorage.getItem( "orderInPreOrder" ) == 'true')
        )
        {
            /*if (product.slug === 'BN-EVJWC2Q')
            {
                console.log(product.availableTimes)
                console.log(product.title)
                console.log(currentTime)
            }*/
            product.availableTimes.map((availableTime , index) => {
                /*if (product.slug === 'BN-EVJWC2Q')
                {
                    console.log(currentTime)
                    console.log(availableTime.key)
                    console.log(availableTime.value)
                    console.log('--------')
                }*/
                /*console.log(currentTime)
                console.log(availableTime.key)
                console.log(availableTime.value)*/
                if (parseInt(availableTime.key) === parseInt(currentTime) && availableTime.value === true)
                {
                    available = true
                }
                if (availableTime.value === true && availableShowForPreOrderMessage === null && parseInt(availableTime.key) > parseInt(currentTime))
                {
                    /*if (product.slug === 'BN-PLHNNQ8')
                    {
                        console.log('c'+currentTime,availableTime.key)
                    }*/
                    availableShowForPreOrderMessage = 'زمان ارائه محصول از ساعت ' + availableTime.key + ' میباشد.'
                }
            })

            /*if (product.slug === 'BN-EVJWC2Q')
            {
                console.log(availableShowForPreOrderMessage)
            }*/
        }

        //if (Boolean(product.available) === true && available === false && availableShowForPreOrderMessage !== null)
        if (available === false && availableShowForPreOrderMessage !== null)
        {
            unavailableForPreOrder = true
        }
        if (available === true)
        {
            availableShowForPreOrderMessage = null
            imgClass = 'img-container'
        }
        else if(unavailableForPreOrder === true)
        {
            imgClass = 'img-container unavailable-for-preorder'
        }
        else
        {
            imgClass = 'img-container deactivate'
        }



        let qty = product.qty
        if (!isNaN(this.props.cart[product.id]) || this.props.cart[product.id] !== undefined )
        {
            qty = this.props.cart[product.id]
        }
        const { gallerySlider } = this.state;
        const images = Array.isArray(gallerySlider)
            ? gallerySlider
            : gallerySlider
                ? [gallerySlider]
                : [];
        //console.log(gallerySlider)

        return (
            <div className="card-custom-4">
                <div className="row no-gutters">
                    <div className="col-auto pl-1">
                        <div className={imgClass} onClick={this.galleryShowHandler.bind(this)}>
                            <img className="item-icon" src={product.imagePreview} alt={product.title} />
                        </div>
                    </div>

                    <div className="col pr-1">
                        <div className="row no-gutters flex-column justify-content-between  h-100">
                            <div className="top">
                                <div className="title">
                                    {product.title}
                                    {
                                        product.discountPercent !== 0 ?
                                        (
                                          <span className="discount-percent">
                                              {product.discountPercent}
                                              %
                                          </span>
                                        )
                                        :
                                        (``)
                                    }
                                </div>
                                <div className="lead">
                                    {product.lead}
                                    {imgClass === 'img-container' && orderInPreOrder === false && daily_stock_count_sens_status === true  && daily_stock_count > 0? (
                                        <div className="stock-count">
                                            {daily_stock_text}
                                        </div>
                                    ) : ''}

                                    {unavailableForPreOrder === true ? (
                                        <div className="unavailable-for-preorder">
                                            {availableShowForPreOrderMessage}
                                        </div>
                                    ) : ''}

                                </div>
                            </div>
                            <div className="bottom">
                                <div className="row no-gutters align-items-center justify-content-between">
                                    <div className="col-auto">
                                        {
                                            product.price !== product.priceWithDiscount ?
                                                (
                                                    <div className="price-container has-discount">
                                                        <div className="price d-inline-block">
                                                            <NumberFormat value={product.price} displayType={'text'} thousandSeparator={true}  />
                                                        </div>
                                                        <div className="price-with-discount d-inline-block">
                                                            <NumberFormat value={product.priceWithDiscount} displayType={'text'} thousandSeparator={true}  />
                                                            <span className="currency">
                                                                تومان
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) :
                                                (
                                                    <div className="price-container">
                                                        <div className="price-with-discount">

                                                            <NumberFormat value={product.priceWithDiscount} displayType={'text'} thousandSeparator={true}  />
                                                            <span className="currency">
                                                                تومان
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                        }
                                    </div>
                                    <div className="col-auto text-left">

                                        {
                                            available === true ?
                                            (
                                                <div className="qty-container">

                                                    {qty !== 0 ? (
                                                        <div className="button-minus-container">
                                                            <button className="btn btn-custom-1" onClick={this.buttonMinusHandler.bind(this)}>
                                                                <img src={buttonMinusIcon} alt="button-minus"/>
                                                            </button>
                                                        </div>
                                                    ) : (``)}


                                                    {qty !== 0 ? (
                                                        <div className="qty-count-container">
                                                            {qty}
                                                        </div>
                                                    ) : (``)}

                                                    <div className="button-plus-container">
                                                        <button className="btn btn-custom-1" onClick={this.buttonPlusHandler.bind(this)}>
                                                            <img src={buttonPlusIcon} alt="button-plus"/>
                                                        </button>
                                                    </div>

                                                </div>
                                            )
                                                :
                                            (
                                                <div className="button-plus-deactivate-container">
                                                    <img src={buttonPlusDeactivateIcon} alt="button-plus-deactivate"/>
                                                </div>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Modal show={this.state.galleryShowModal} onHide={() => this.setState({galleryShowModal:false})} className="bottom-sheet modal-custom-1" centered>

                    <Modal.Body>
                        <div className="title">
                            {/*<img src={timerIcon} alt="timer" className="item-icon" />*/}
                            گالری تصاویر
                            <span style={{color:'#e7b500', paddingRight: '5px'}}>
                                "{product.title}"
                            </span>
                        </div>
                        <div className="lead" style={{fontSize: '14px',color: '#2b2b2b', marginTop: '6px'}}>
                            {product.lead}
                        </div>
                        <div className="mt-3">

                            <div className="swiper-container" id="gallery-slider" dir="rtl">
                                <div className="swiper-wrapper">


                                    {images.length > 0 ? (
                                        images.map((object, index) => (

                                            <div className="swiper-slide" key={index}>
                                                <div className="img-container">

                                                    {/*<img
                                                        src={object.original}
                                                        alt={product.title}
                                                        className="item-icon"
                                                    />*/}

                                                    {!this.state.loadedImages[index] && (
                                                        <div className="image-loader">
                                                            در حال بارگذاری...
                                                        </div>
                                                    )}

                                                    <img
                                                        src={object.original}
                                                        alt={product.title}
                                                        className="item-icon"
                                                        style={{ display: this.state.loadedImages[index] ? 'block' : 'none' }}
                                                        onLoad={() => {
                                                            this.setState(prev => ({
                                                                loadedImages: {
                                                                    ...prev.loadedImages,
                                                                    [index]: true
                                                                }
                                                            }))
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div>تصویری موجود نیست</div>
                                    )}

                                </div>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({
    addToCart : productId => dispatch(addToCart(productId)) ,
    addToUserCart : productId => dispatch(addToUserCart(productId)) ,


    removeFromCart : productId => dispatch(removeFromCart(productId)) ,
    removeFromUserCart : productId => dispatch(removeFromUserCart(productId)) ,
})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(ProductCard);